<template>
  <div>
    <h4>Запись будет скрыта и добавлена в черный список</h4>
    <div class="flex flex_gap_10">
      <button class="btn btn-default" @click="comment = b.title" type="button" v-for="b in btns">{{ b.title }}</button>
    </div>
    <textarea v-model="comment" class="form-control mt-2" placeholder="Комментарий" rows="2"/>
  </div>
</template>
<script>
import api from "@/api";

export default {
  props: ['data'],
  data() {
    return {
      comment: '',
      btns: [
        {title: 'Препарат в списке контролируемых'},
        {title: 'Препарат не из нашей торговой группы'},
        {title: 'Препарат рос. производства'},
      ],
    }
  },
  methods: {
    async updateRecord() {
      const {data} = await api.post('/statistics/003/codes', {
        action: 'updateStatus',
        status_type: 'black_list',
        data: {comment: this.comment},
        drug_id: this.data.record?.drug_id,
      })
      if (data.success) {
        return {success: true};
      }
      return {success: false};
    }
  }
}

</script>
